var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropUpFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85227 12.0894L6.14844 13.3828L11.0004 8.53457L15.8523 13.3828L17.1484 12.0857L12.2965 7.24116C11.9527 6.89746 11.4865 6.70438 11.0004 6.70438C10.5142 6.70438 10.048 6.89746 9.70419 7.24116L4.85227 12.0894Z",
    fill: "#331400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUpFilledIcon);
export default __webpack_public_path__ + "static/media/dropUpFilledIcon.7f3d85dd448ae0a4f4821b636fdfbcfe.svg";
export { ForwardRef as ReactComponent };